import {BreadcrumbItem, BreadcrumbLink, Breadcrumbs, View, ViewHeader} from "@variocube/app-ui";
import React from "react";
import {useAsync} from "react-async-hook";
import {Link, useNavigate} from "react-router-dom";
import {CreditorMutation, useCreditorApi} from "../../../api";
import {useLocalization} from "../../../i18n";
import {useNumericParam} from "../../../utils/useParam";
import {CreditorForm} from "./form";

export function CreditorEdit() {
	const navigate = useNavigate();
	const {t} = useLocalization();
	const {getCreditor, updateCreditor} = useCreditorApi();

	const id = useNumericParam("id");

	const {loading, error, result} = useAsync(getCreditor, [id]);

	async function handleSave(mutation: CreditorMutation) {
		if (result !== undefined) {
			await updateCreditor(result.id, mutation);
			navigate(-1);
		}
	}

	return (
		<View loading={loading} error={error}>
			<Breadcrumbs>
				<BreadcrumbItem>{t("navigation.admin")}</BreadcrumbItem>
				<BreadcrumbLink component={Link} relative="path" to={"../.."}>{t("creditors.plural")}</BreadcrumbLink>
				<BreadcrumbLink component={Link} relative="path" to={".."}>
					{result?.company.companyName}
				</BreadcrumbLink>
				<BreadcrumbItem>{t("creditors.edit.title")}</BreadcrumbItem>
			</Breadcrumbs>
			<ViewHeader
				title={t("creditors.edit.title")}
			/>
			<CreditorForm
				loading={loading}
				creditor={result}
				onSave={handleSave}
				onCancel={() => navigate("../admin/creditor")}
			/>
		</View>
	);
}
